import { FinancialType } from '../constants';

export const transformDataPointValues = (
  dataPointValues: { id: number; value: number }[]
) => Object.fromEntries(Object.entries(({
  budget: dataPointValues.find((v) => v.id === FinancialType.Budget)?.value ?? undefined,
  resources: dataPointValues.find((v) => v.id === FinancialType.Resources)?.value ?? undefined,
  runningCost: dataPointValues.find((v) => v.id === FinancialType.Cost)?.value ?? undefined,
})).filter(([_, value]) => value !== undefined));
